<template>
  <div class="container-fluid Section--light">
      <div class="container">
        <div class="row">

          <div class="col-md-8 col-lg-4 mx-auto Reveal--sequenced">
            <app-tip :imgFileName="'ideum-trade-shows--2x3--400.jpg'">
              <h4 class="Tip-title" slot="Tip-title">
                Trade Shows
              </h4>
              <p class="Tip-body" slot="Tip-body">
                Stand out in the crowded trade show market by showing your products to clients using innovative and engaging multitouch technology.
              </p>
            </app-tip>
          </div>

          <div class="col-md-8 col-lg-4 mx-auto Reveal--sequenced">
            <app-tip :imgFileName="'ideum-events--3x2--400.jpg'">
              <h4 class="Tip-title" slot="Tip-title">
                Events
              </h4>
              <p class="Tip-body" slot="Tip-body">
                Provide an entertaining and engaging experience at your next event with an interactive multitouch table made by Ideum.
              </p>
            </app-tip>
          </div>

          <div
            class="col-md-8 col-lg-4 mx-auto Reveal--sequenced"
            style="z-index: 9">
            <app-tip :imgFileName="'ideum-development--2x3--400.jpg'">
              <h4 class="Tip-title" slot="Tip-title">
                Development
              </h4>
              <p class="Tip-body" slot="Tip-body">
                Ideum's <a href="http://gestureworks.com/" target="_blank" rel="noopener">GestureWorks</a> multitouch software framework and <a href="https://tangibleengine.com/" target="_blank" rel="noopener">Tangible Engine</a>, the innovative authoring solution for tangible user interaction, are also available.
              </p>
            </app-tip>
          </div>
          
        </div>
      </div>
    </div>
</template>

<script>
import appTip from './Tip'
export default {
  components: {
    appTip
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

a {
  color: $colorEmerald;
}

.Section--light {
  background-color: $colorLightgray;
  margin: -5em 0 0 0;
  padding: 12em 0 18em 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Product-tips.vue